import { render } from "./TenSecondsCallsCard.vue?vue&type=template&id=7cd3e138"
import script from "./TenSecondsCallsCard.vue?vue&type=script&lang=js"
export * from "./TenSecondsCallsCard.vue?vue&type=script&lang=js"
script.render = render

export default script